<template lang="pug">
v-container.pa-0
  .text-editor.mb-4
    froala(id="edit" :tag="'textarea'" :config="config" v-model="form" @focus="" ref="editor" )
  .text-sm.font-medium {{ $t('insert_smart_fields') }}
  .text-xs.font-normal {{ $t('smart_fields_description') }}
  .field-type
    v-layout.mt-2.mx-n1
      v-item-group
        template(v-for="(field, index) in smartFields")
          v-item.mb-2(:key="`smf-${index}`")
            v-btn.button-xs.round-3xl.mx-1.neutral700--text.field-outline(small outlined @click="onInsertField(field.name)") {{ field.label }}
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins/table.min.js'
import 'froala-editor/js/plugins/font_size.min.js'
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'})
 
export default {
  name: 'TextEditor',
  props: ['parentForm', 'category'],
  data: () => ({
    isLoading: false,
    config: {
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      toolbarSticky: false,
      toolbarBottom: false,
      toolbarButtons: {
        'moreText': {
          buttons: ['fontSize', 'bold', 'italic', 'underline', 'align', 'formatUL', 'undo', 'redo','insertTable'],
          'buttonsVisible': 8
        }
      },
      quickInsertEnabled: false,
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
      imageResizeWithPercent: true,
      fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
      paragraphFormat: {
        N: 'Normal',
        H1: 'Heading 1',
        H2: 'Heading 2',
        H3: 'Heading 3',
        H4: 'Heading 4',
      },
      heightMin: 200,
      heightMax: 270,
      enter: FroalaEditor.ENTER_BR
    },
  }),
  computed: {
    form: {
      get () {
        return this.parentForm
      },
      set (newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
    smartFields () {
      let fields = [
        { name: 'patient_name', label: this.$t('patient_name') },
        { name: 'doctor_name', label: this.$t('doctor_name') },
        { name: 'visit_date', label: this.$t('visit_date') },
        { name: 'identification', label: this.$t('identification') },
        { name: 'age', label: this.$t('age') },
        { name: 'time_in', label: this.$t('time_in') },
        { name: 'diagnosis', label: this.$t('diagnosis') }
      ]
      if (this.category === 'patient_label') {
        fields = [
          { name: 'name', label: this.$t('patient_name') },
          { name: 'identification', label: this.$t('identification') },
          { name: 'age', label: this.$t('age') },
          { name: 'gender', label: 'Gender' },
          { name: 'visit_date', label: this.$t('visit_date') },
          { name: 'doctor_name', label: this.$t('doctor_name') },
          { name: 'address', label: this.$t('address') },
        ]
      }
      return fields
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    onInsertField (field) {
      const editor = this.$refs?.editor?.$el['data-froala.editor']
      editor.html.insert(`{{${field}}}`, true)
      const newValue = editor.html.get()
      this.$emit('update:parentForm', newValue)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .fr-box .fr-counter {
  visibility: hidden !important;
}

::v-deep p {
  margin-bottom: 0px !important;
}

::v-deep ul, ol {
  padding-left: 0px;
}

::v-deep li {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 24px !important;
  line-height: 24px !important;
}


::v-deep .fr-box.fr-basic .fr-element.fr-view {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 24px !important;
  line-height: 24px !important;
  color: #000000;
}

.border-outline {
  border: 1px solid #EEEEEE !important;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .combostyle .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
}
::v-deep .v-ripple__container {
  display:none !important;
}
.field-outline {
  border: 1px solid var(--v-neutral400) !important;
}

</style>

